<template>
	<h1>Oops, that page could not be found</h1>
</template>